import React from 'react';
import {HashRouter, Route} from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Navbar from './Navbar';
import Footer from './Footer';
import HomePage from './Home';
import Login from './Login';
import Register from './Register'

class App extends React.Component{

    state = {
        login:false,
        isLoggedIn:false,
        loading:true
    }

    componentDidMount(){
        this.setState({isLoggedIn:localStorage.getItem('isLoggedIn') || false });
        console.log(localStorage.getItem('isLoggedIn'));
        if(localStorage.getItem('isLoggedIn')){
            toast.success('You are logged In, Start Applying',{
                position: "top-center",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                })
        }
    }

    updateModal = (value) => {
        this.setState({login:value})
    }

    updateLogin = (value) => {
        this.setState({isLoggedIn:value})
    }

    updateLoading = (value) => {
        this.setState({loading:value})
    }

    render(){

        return(
            <HashRouter>
                <div className="loading" style={{display:this.state.loading ? 'flex' : 'none' }}>
                    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
                <Login 
                    showModal={this.state.login} 
                    updateModal={this.updateModal} 
                    updateLogin={this.updateLogin}
                     />
                <Navbar 
                    updateModal={this.updateModal} 
                    isLoggedIn={this.state.isLoggedIn}  
                    updateLogin={this.updateLogin} 
                     />
                <Route path="/" exact >
                    <HomePage 
                        updateModal={this.updateModal}
                        login={this.state.isLoggedIn}
                        updateLoading={this.updateLoading} 
                            />
                </Route>
                <Route path="/register" exact component={Register} ></Route>
                <Footer/>
                <ToastContainer
                    bodyClassName="toastBody"
                    position="top-center"
                    autoClose={false}
                    newestOnTop={true}
                />
            </HashRouter>

        )
    }
};

export default App;